import { io } from "socket.io-client";

// const URL = "http://localhost:3020";
const URL = "https://server.lmeetup.com";

// export const socket = io(URL, {
//   autoConnect: false,
// });

export const socket = io(URL, {
    autoConnect: false,
    transports: ["websocket"],
    withCredentials: true,
})
